import { createContext, type PropsWithChildren, useContext } from 'react';

/**
 * Host-provided display surface for ViewJob. This is session/host context, not
 * job data, so it is carried independently of `ViewJobClientSideModel` /
 * `ViewjobOneGraphModel`. The root `App` resolves it once (from the host
 * `viewJobDisplay` prop, falling back to a preloaded model's `rnViewJobDisplay`)
 * and provides it here; components read it via these hooks instead of reaching
 * into the data model.
 */
export type RnViewJobDisplay = Exclude<viewjob.factory.ViewJobDisplay, 'MOBILE_NATIVEAPP'>;

const ViewJobDisplayContext = createContext<RnViewJobDisplay>('MOBILE_STANDALONE');

export function ViewJobDisplayProvider({
    display,
    children,
}: PropsWithChildren<{ display: RnViewJobDisplay }>) {
    return (
        <ViewJobDisplayContext.Provider value={display}>{children}</ViewJobDisplayContext.Provider>
    );
}

export function useRnViewJobDisplay(): RnViewJobDisplay {
    return useContext(ViewJobDisplayContext);
}

export function isDesktopDisplay(display: RnViewJobDisplay): boolean {
    return display === 'DESKTOP_STANDALONE' || display === 'DESKTOP_EMBEDDED';
}

export function useIsDesktopDisplay(): boolean {
    return isDesktopDisplay(useRnViewJobDisplay());
}
